import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from '../../../components/Header/Header';
import Tiles from '../../../components/Tiles/Tiles';
import { showAppModal, hideAppModal } from '../../../actions/appActions';
import Spinner from '../../../components/Spinner/Spinner';
import './Templates.css';

class Templates extends Component {
  state = {
    templates: undefined,
    selectedTemplate: null,
    templateName: '',
    signs: [],
  };

  handleTileClick = item => {
    const { showAppModal, hideAppModal } = this.props;

    this.setState({ selectedTemplate: item, templateName: item.name }, () => {
      showAppModal({
        show: true,
        content: 'TemplateNameModal',
        title: 'Create sign from template',
        data: {
          value: '',
          placeholder: 'New sign name',
          onChange: value => {
            this.setState({ templateName: value });
          },
        },
        cancelFn: () => hideAppModal(),
        confirmFn: () => {
          const { selectedTemplate, templateName } = this.state;
          const usedSignNames = this.state.signs.map(sign => sign.name);
          const duplicatedName = usedSignNames.some(
            name => name.toLowerCase() === templateName.toLowerCase(),
          );

          if (duplicatedName) {
            alert('A sign with this name already exists. Please choose a different name.');

            return;
          }

          // hideAppModal();
          // put request to API to create new signage from template, /signs/:signId/template/:name
          fetch(`/cms/data/v1/signs/${selectedTemplate?.id}/template/${templateName}`, {
            method: 'PUT',
          })
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }

              return response.json();
            })
            .then(data => {
              globalThis.location.href = `/signs/${data.id}`;
            })
            .catch(error => {
              alert(`Error creating signage: ${error.message}`);
            });
        },
      });
    });
  };

  getAllSigns = () => {
    const { signs } = this.state;

    if (signs.length > 0) {
      return;
    }

    // call GET endpoint /signs to get list of signs
    fetch('/cms/data/v1/signs', {
      method: 'GET',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return response.json();
      })
      .then(data => {
        this.setState({
          signs: data.signs,
        });
      });
  };

  getTemplates = () => {
    const { templates } = this.state;

    if (templates !== undefined) {
      console.log('Templates already loaded');

      return;
    }

    // call GET endpoint /signs/templates to get list of templates
    fetch('/cms/data/v1/signs/templates', {
      method: 'GET',
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return response.json();
      })
      .then(data => {
        this.setState({
          templates: data.map(template => {
            const published = template.published ? 'published' : 'unpublished';

            return {
              id: template.id,
              name: template.name,
              imageUrl: `/cms/data/v1/signs/${template.id}/${published}/thumbnail`,
            };
          }),
        });
      });
  };

  render() {
    this.getTemplates();
    this.getAllSigns();
    const { templates } = this.state;

    return (
      <div className="page-structure">
        <Helmet title="Templates" />
        <Header />
        <div className="mt-8">
          <div className="page-panels">
            <div className="page-content page-home page-templates">
              <Spinner
                loading={templates === undefined}
                extraText="The Goblins are trying to fetch your templates..."
              >
                {!templates?.length && <p>No templates found.</p>}
                {templates?.length && (
                  <Tiles items={templates} onTileClick={this.handleTileClick} />
                )}
              </Spinner>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Templates.propTypes = {
  showAppModal: PropTypes.func.isRequired,
  hideAppModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  showAppModal,
  hideAppModal,
};

export default connect(null, mapDispatchToProps)(Templates);
